document.addEventListener('turbolinks:load', () => {
  // Get a parent element that exists when the page loads
  const parent = document.body
  const appElement = document.getElementById('app-component')

  // Add a single click event listener to the parent element
  parent.addEventListener('click', async (e) => {
    const button = e.target.closest('.create-post-nav-button:not([data-upgrade-required])')

    // Check if the clicked element is inside a '.create-post-nav-button'
    if (button) {
      startLoading()

      // Hide the modal
      $('.modal').modal('hide')

      e.preventDefault()

      const publicationGroupId = button.getAttribute('data-publication-group-id')
      const action = button.getAttribute('data-initial-action')
      const date = button.getAttribute('data-publish-date')
      const mediaId = button.getAttribute('data-media-id')
      const propertyId = button.getAttribute('data-property-id')
      const specialDayId = button.getAttribute('data-special-day-id')
      const snName = button.getAttribute('data-sn-name')
      const duplicate = Boolean(button.getAttribute('data-duplicate'))

      const { default: React } = await import('react')
      const { createRoot } = await import('react-dom/client')
      const { default: CreatePostContainer } = await import('../../react/containers/CreatePostContainer')
      const { default: i18n } = await import('../../react/locales/create-post/i18n') // import the i18n configuration

      // Set the locale from Rails
      const locale = document.documentElement.getAttribute('lang') || 'fr'
      await i18n.changeLanguage(locale)

      // Unmount the previous root if it exists
      if (window.appRoot) {
        window.appRoot.unmount()
      }

      // Create a new root and render the CreatePostContainer component
      window.appRoot = createRoot(appElement)
      window.appRoot.render(
        <CreatePostContainer publicationGroupId={publicationGroupId} initialAction={action} publishDate={date} mediaId={mediaId} propertyId={propertyId} specialDayId={specialDayId} snName={snName} duplicate={duplicate} />
      )

      stopLoading()

      $('body').addClass('modal-open')
    }
  })
})

const startLoading = () => {
  // Create a new div element
  const newDiv = document.createElement('div')
  newDiv.className = 'create-post-modal__loading-screen'

  // Select the element with id 'app-component'
  const appComponent = document.getElementById('app-component')

  // Insert the new div after the app-component element
  appComponent.parentNode.insertBefore(newDiv, appComponent.nextSibling)
}

const stopLoading = () => {
  // Select all elements with the class 'create-post-modal__loading-screen'
  const loadingScreens = document.querySelectorAll('.create-post-modal__loading-screen')

  // Loop through the NodeList and remove each element
  loadingScreens.forEach(function (loadingScreen) {
    loadingScreen.remove()
  })
}
